import React from 'react';
import { motion } from 'framer-motion';
import { useMediaQuery } from 'react-responsive';
import two_girls from '../../../assets/images/speech_therapy/two_girls.jpg';
function MemberCommunication() {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
  const paragraphStyles = `text-lg xl:text-[25px] leading-10`;

  return (
    <div className="bg-[#F0EFEF]">
      <div className="w-full flex flex-col justify-between gap-4 sm:gap-10 max-w-[1200px] mx-auto px-4 md:px-10 py-10 md:py-20 relative z-10">
        <div>
          <h2 className="text-[32px] sm:text-[42px] md:text-[48px] text-[#7B54A2] font-bold leading-[40px] lg:leading-[50px] md:mr-4">
            Benefits of <br /> Pediatric Speech Therapy
          </h2>
        </div>
        <div className="flex flex-col lg:flex-row justify-between w-full gap-4 sm:gap-10 xl:gap-32">
          <div className="flex-1 flex flex-col items-start gap-4 sm:gap-6 lg:gap-10 font-custom text-lg md:text-xl 2xl:text-2xl ">
            <h4 className="text-[#7B54A2] text-[28px] lg:text-[30px] xl:text-[33px] font-semibold leading-10">
              Our speech-language pathologists offer treatment programs
              specifically designed to treat all aspects of communication.
              Pediatric speech therapy can assist with your child's first words
              and their ability to socialize and interact with peers.
            </h4>
          </div>
          <div className="flex-1 flex justify-center">
            <motion.div
              initial={{ opacity: 0, x: isMobile ? 0 : 300 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, ease: 'easeInOut' }}
              viewport={{ once: true, amount: 0.3 }}
            >
              <img
                src={two_girls}
                alt="Speech therapy social skills activity in Wasilla, AK"
                className="rounded-xl"
              />
            </motion.div>
          </div>
        </div>
        <div className="condition_modal">
          <motion.div
            id="TelehealthModal"
            initial={{ x: isMobile ? '0 ' : '-50%', opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1, ease: 'easeInOut' }}
            style={{
              background:
                'linear-gradient(-45deg, #493F99 0%, #755EA8 67%, #D36CAA 100%)',
            }}
            className="w-full rounded-2xl md:rounded-[50px] p-6 md:px-14 md:pt-10 md:pb-16 mt-4 md:mt-10"
          >
            <div
              className={`paragraph-styles flex flex-col gap-6 text-white font-medium`}
            >
              <h2 className="text-[32px] sm:text-[42px] md:text-[48px] font-bold leading-[40px] lg:leading-[50px] md:mr-4">
                Pediatric speech-language therapy can benefit children with
                conditions including:
              </h2>

              <div
                className={`flex flex-col lg:flex-row justify-between gap-x-10 gap-y-4 text-left mt-4 ${paragraphStyles}`}
              >
                <ul className="flex-1 list-disc pl-5 space-y-2">
                  <li>
                    <p>Apraxia of speech</p>
                    <ul className="list-[circle] pl-5">
                      <li>A disorder causing limited and difficult speech</li>
                    </ul>
                  </li>
                  <li>
                    <p>Articular and phonological disorders</p>
                    <ul className="list-[circle] pl-5">
                      <li>Difficulty producing sounds and reading aloud</li>
                    </ul>
                  </li>
                  <li>
                    <p>Auditory processing disorders</p>
                  </li>
                  <li>
                    <p>Autism spectrum disorders</p>
                    <ul className="list-[circle] pl-5">
                      <li>
                        Can cause difficulties with social communication and
                        behavior
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p>Cognitive and attention impairments</p>
                    <ul className="list-[circle] pl-5">
                      <li>
                        Including those associated with traumatic brain injury
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p>Craniofacial abnormalities</p>
                    <ul className="list-[circle] pl-5">
                      <li>Includes cleft lip and palate</li>
                    </ul>
                  </li>
                </ul>

                <ul className=" flex-1 list-disc pl-5 space-y-2">
                  <li>
                    <p>Delayed speech milestones</p>
                  </li>
                  <li>
                    <p>Fluency disorders such as stuttering</p>
                  </li>
                  <li>
                    <p>Genetic syndromes</p>
                    <ul className="list-[circle] pl-5">
                      <li>
                        Such as Down syndrome, which can cause developmental and
                        intellectual delays
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p>Hearing impairments</p>
                  </li>
                  <li>
                    <p>Listening skills</p>
                  </li>
                  <li>
                    <p>Neurological disorders</p>
                    <ul className="list-[circle] pl-5">
                      <li>
                        Includes cerebral palsy, stroke and traumatic brain
                        injury
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p>Reasoning and memory skills</p>
                  </li>
                  <li>
                    <p>Receptive and expressive language disorders</p>
                  </li>
                  <li>
                    <p>Social pragmatic communication disorders</p>
                  </li>
                </ul>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default MemberCommunication;
